import { useState, useCallback } from 'react';

export const useStatusMessage = () => {
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success');
  const [isVisible, setIsVisible] = useState(false);

  const showMessage = useCallback((text, messageType = 'success') => {
    setMessage(text);
    setType(messageType);
    setIsVisible(true);
  }, []);

  const hideMessage = useCallback(() => {
    setIsVisible(false);
  }, []);

  const showSuccess = useCallback((text) => {
    showMessage(text, 'success');
  }, [showMessage]);

  const showError = useCallback((text) => {
    showMessage(text, 'error');
  }, [showMessage]);

  const showWarning = useCallback((text) => {
    showMessage(text, 'warning');
  }, [showMessage]);

  const showInfo = useCallback((text) => {
    showMessage(text, 'info');
  }, [showMessage]);

  return {
    message,
    type,
    isVisible,
    showMessage,
    hideMessage,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};

export default useStatusMessage;
